/**
 * Module to handle utility / helper methods.
 *
 * @module utils
 */
var utils = {

  /**
   * Method to handle converting NodeLists to Arrays.
   *
   * @method utils.convertNodeListToArray
   */
  convertNodeListToArray: function(nodes) {

    var list = [];

    for (var index = 0; index < nodes.length; index++) {
      list.push(nodes[index]);
    }

    return list;

  },

  /**
   * Method to set a cookie with optional expiry.
   *
   * @method utils.setCookie
   */
  setCookie: function(value, duration) {

    // Default expiry to 10 years
    var age = 60 * 60 * 24 * 365 * 10;

    // If duration specified, use that instead
    if (duration > 0) {
      age = duration * 24 * 60 * 60;
    }

    // Set the cookie, specifying the expiry and secure/strict settings
    document.cookie = [
      value,
      "max-age=" + age,
      "secure=true",
      "samesite=strict",
    ].join("; ");

  },

};
